import styled from 'styled-components';

export const StyledFiltersOptions = styled.div`
  margin-left: auto;
`;

export const StyledFilters = styled.div`
  display: flex;
  align-items: flex-start;
  margin-left: 1rem;
  width: 100%;
  gap: 1rem;
  justify-content: space-between;
`;
